
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/medical-posters",
      function () {
        return require("private-next-pages/medical-posters.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/medical-posters"])
      });
    }
  